import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {useHistory} from "react-router-dom";
import {FormattedMessage} from "react-intl";

// Material UI
import {Grid} from "@mui/material";

// Components
import CustomButton from "components/CustomButton";
import Popup from "../Popup";

// API
import {stopMission} from "api/wms/tasks/stop";

// Contexts
import {WMSContext} from "views/wms/context/WMSContext";

// Utils
import {WMSRoutes} from "utils/WMSRoutes";

// Assets
import StopMissionIcon from "assets/img/wms/stop_mission.svg";

CancelPopup.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element])
}

function CancelPopup({open, handleClose, subtitle}) {
    const {currentMember, currentTask} = useContext(WMSContext);

    const history = useHistory();

    function onClick() {
        stopMission(currentTask, currentMember).then(() => {
            handleClose();
            history.push(WMSRoutes.PICKING)
        })
    }

    const Icon = () => (
        <img
            src={StopMissionIcon}
            alt={"Stop mission"}
            style={{
                width: '48px',
                height: '48px',
            }}
        />
    );

    return (
        <Popup
            open={open}
            onClose={handleClose}
            title={(<FormattedMessage id='wms.myPickingMissions.popup.cancel.title' />)}
            subtitle={subtitle}
            icon={(<Icon />)}
        >
            <Grid container>
                <Grid
                    container
                    item
                    direction={"column"}
                    gap={2}
                >
                    <CustomButton
                        onClick={handleClose}
                        color={'default'}
                        fullWidth={true}
                    >
                        <FormattedMessage id='wms.myPickingMissions.popup.cancel.cancel' />
                    </CustomButton>
                    <CustomButton
                        onClick={onClick}
                        color={'red'}
                        fullWidth={true}
                    >
                        <FormattedMessage id='wms.myPickingMissions.popup.cancel.yes' />
                    </CustomButton>
                </Grid>
            </Grid>
        </Popup>
    );
}

export default CancelPopup;
